<template>
	<sf-data-table
		:excel="isButton_(scrId, 'EX')"
		:customExcel="excelFunc"
		:columns="columns"
		:rows="rows"
		index
		height="100%"
		paging
		:pageUnit="pageUnit_"
		:pageArray="screen.pageArray"
		:totalSize="totalSize_"
		@changedPage="changedPage"
	>
		<!-- <template v-slot:customRows="slotProps">
			<template v-if="slotProps.column.property === 'pgmId'">
				<span @click="() => onClick(slotProps.row)" :style="{ color: 'blue', fontWeight: 'bold', cursor: 'pointer' }">
					{{ slotProps.row.pgmId }}
				</span>
			</template>
		</template> -->
	</sf-data-table>
</template>

<script>
// import columns from './columns';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/ProgramRegistration/store/helpers';
import { utils } from '@sfaas/util';
import { BASE_URL } from '@/constants';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			screen: {}
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		columns() {
			return [
				{
					// label: 'Program ID',
					label: this.getMessage_('SWCC000255'),

					// msgKey: 'SWCC000255',
					prop: 'pgmId',
					width: 200,
					clickEvent: this.onClick,
					highlight: true
				},
				{
					label: this.getMessage_('SWCC000256'),

					// label: '프로그램명',
					// msgKey: 'SWCC000256',
					prop: 'pgmName',
					width: 450
				},
				{
					// label: '서비스',
					label: this.getMessage_('SWCC000250'),

					// msgKey: 'SWCC000250',
					prop: 'serviceKind',
					width: 200
				},
				{
					// label: 'Server Name',
					label: this.getMessage_('SWCC000249'),

					// msgKey: 'SWCC000249',
					prop: 'serverName',
					width: 350
				},
				{
					// label: '메인Flg',
					label: this.getMessage_('SWCC000257'),

					// msgKey: 'SWCC000257',
					prop: 'mainFlg',
					width: 200
				},
				{
					// label: 'Shop',
					label: this.getMessage_('SWCC000248'),

					// msgKey: 'SWCC000248',
					prop: 'shopCd',
					width: 200
				},
				{
					// label: '라인 명',
					label: this.getMessage_('SWCC000254'),

					// msgKey: 'SWCC000254',
					prop: 'lineCd',
					width: 200
				},
				{
					// label: '프로그램 url',
					label: this.getMessage_('SWCC000945'),

					// msgKey: 'SWCC000945',
					prop: 'pgmUrl',
					width: 200
				}
			];
			// return columns.map(column => ({ ...column, label: this.getMessage_(column.msgKey) }));
		},
		rows() {
			return this.programs.map(program => ({
				...program,
				serviceKind: this.serviceKindConverter(program.serviceKind),
				shopCd: this.shopCdConverter(program.shopCd),
				lineCd: this.lineCdConverter(program.lineCd),
				mainFlg: this.mainFlgConverter(program.mainFlg)
			}));
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		...utils,
		excelFunc() {
			const url = `${BASE_URL}/program/v1/plants/${this.user.plantCd}/programs`;
			const params = { url, columns: this.columns };
			this.xlsxDown(params).catch(error => {
				this.$sf_toast({ type: 'error', message: error.message });
			});
		},
		changedPage({ currentPageVal, pageUnitVal }) {
			Promise.resolve()
				.then(() =>
					this.DEFAULT_ASSIGN({ key: 'pagingInfo', value: { ...this.pagingInfo, currentPage: currentPageVal, pageUnit: pageUnitVal } })
				)
				.then(this.findAllPrograms);
		},
		onClick(selectedRow) {
			this.DEFAULT_ASSIGN({
				key: 'popupParams',
				value: {
					type: 'update',
					show: true,
					selectedRow: {
						...selectedRow,
						serviceKind: this.serviceKindConverter(selectedRow.serviceKind),
						shopCd: this.shopCdConverter(selectedRow.shopCd),
						lineCd: this.lineCdConverter(selectedRow.lineCd),
						mainFlg: this.mainFlgConverter(selectedRow.mainFlg)
					}
				}
			});
		},
		mainFlgConverter(mainFlg) {
			switch (mainFlg) {
				case 'M':
					return 'MAIN';
				case 'B':
					return 'BACKUP OR STANDBY';
				case 'MAIN':
					return 'M';
				case 'BACKUP OR STANDBY':
					return 'B';
				default:
					return '';
			}
		},
		serviceKindConverter(serviceKind) {
			switch (serviceKind) {
				case 'D':
					return 'DEMON';
				case 'T':
					return 'TERMINAL';
				case 'W':
					return 'WEB';
				case 'DEMON':
					return 'D';
				case 'TERMINAL':
					return 'T';
				case 'WEB':
					return 'W';
				default:
					return '';
			}
		},
		shopCdConverter(shopCd) {
			switch (shopCd) {
				case '*':
					return 'COMMON';
				case 'W':
					return 'BODY';
				case 'P':
					return 'PAINT';
				case 'A':
					return 'ASSEMBLY';
				case 'V':
					return 'PDI';
				case 'COMMON':
					return '*';
				case 'BODY':
					return 'W';
				case 'PAINT':
					return 'P';
				case 'ASSEMBLY':
					return 'A';
				case 'PDI':
					return 'V';
				default:
					return '';
			}
		},
		lineCdConverter(lineCd) {
			switch (lineCd) {
				case '1':
					return 'Line 1';
				case '2':
					return 'Line 2';
				case 'Line 1':
					return '1';
				case 'Line 2':
					return '2';
				default:
					return '';
			}
		},
		findAllPrograms() {
			this.$sf_toggleLoading(true);
			this.fetchPrograms_({ plantCd: this.user.plantCd, urlSearchParams: this.urlSearchParams_ }).finally(() =>
				this.$sf_toggleLoading(false)
			);
		}
	},
	created() {
		this.findAllPrograms();
		this.screen = this.screenArray.get(this.scrId);
	}
};
</script>

<style langType="scss"></style>
